import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton } from "@mui/material";
import type { SnackbarKey } from "notistack";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ariaLabel } from "src/constants/app/aria-labels";
import { useSnackbar } from "src/hooks/useSnackbar";

import {
  type DeployedVersionNotice,
  watchDeployedVersion,
} from "@emeria/front-version-reload";

export function NewVersionNotice(): null {
  const { t } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    const renderActions = (key: SnackbarKey, notice: DeployedVersionNotice) => (
      <>
        <Button color="inherit" onClick={() => window.location.reload()}>
          {t("Recharger")}
        </Button>
        <IconButton
          aria-label={ariaLabel.close}
          color="inherit"
          onClick={() => {
            closeSnackbar(key);
            notice.dismiss();
          }}
        >
          <CloseIcon />
        </IconButton>
      </>
    );

    return watchDeployedVersion({
      // LazyWithRetry retries a failed chunk import before reloading by itself.
      reloadOnStaleChunk: false,
      onNewVersion: (notice) =>
        enqueueSnackbar(
          t("Une nouvelle version de l'application est disponible"),
          {
            variant: "info",
            persist: true,
            action: (key) => renderActions(key, notice),
          },
        ),
    });
  }, [t, enqueueSnackbar, closeSnackbar]);

  return null;
}
